import { collection, collectionGroup, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { Company, CompanyItemMaping } from "../model/Companies";
import { OptionContract, optionContractTimestampToDate } from "../model/OptionContract";


const companiesQuery = {

  //指定した団体を取得
  getCompany: async (tenantId: string) => {
    console.log("companies getCompany access");
    try {
      const companiesRef = await getDoc(doc(db, "companies", tenantId));
      return CompanyItemMaping(companiesRef.data() as Company);
    } catch (err: any) {
      console.error(err);
      return err
    }
  },

  // オプション契約一覧を取得
  getOptionContractList: async (tenantId: string): Promise<OptionContract[]> => {
    console.log("companies getOptionContractList access");
    try {
      const optionContractList: OptionContract[] = [];
      const option = await getDocs(collection(db, `companies/${tenantId}/optionContract`));
      option.docs.forEach((doc) => {
        const targetData = doc.data();
        optionContractList.push(optionContractTimestampToDate(targetData));
      });
      return optionContractList;
    } catch (err: any) {
      console.error(err);
      return [];
    }
  },

  // グループ取得
  getGroupList: async (groupIds: string[], tenantId: string, userId: string): Promise<string[]> => {
    console.log("message getGroupList access");

    // 30件ずつに分割して取得
    const chunkSize = 30;
    const groupIdChunks = [];
    for (let i = 0; i < groupIds.length; i += chunkSize) {
      groupIdChunks.push(groupIds.slice(i, i + chunkSize));
    }

    const groupsSnapshots = await Promise.all(
      groupIdChunks.map(chunk =>
        getDocs(
          query(
            collectionGroup(db, 'groups'),
            where('id', 'in', chunk)
          )
        )
      )
    );
    const groups = groupsSnapshots.flatMap(snapshot => snapshot.docs.map(doc => doc.data()));

    // 利用者が所属しているグループ取得
    const attendingGroupsSnapshot = await getDocs(
      query(
        collectionGroup(db, 'attendingGroups'),
        where('tenantId', '==', tenantId),
        where('userId', '==', userId)
      )
    );
    const attendingGroupIds = attendingGroupsSnapshot.docs.map(doc => doc.id);
    const filteredGroups = groups.filter(group => attendingGroupIds.includes(group.id));
    const groupNames = filteredGroups.map(group => group.name);

    return groupNames;
  }
};

export default companiesQuery;
